// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ShippingInfoResourceViewModel from '../../../../viewModel/resource/ShippingInfoResourceViewModel';
import ShippingInfoResourceDTO from '../../dto/resource/ShippingInfoResourceDTO';

export default abstract class ShippingInfoResourceModel extends BaseModel<ShippingInfoResourceDTO> {
  /**
  * @type {double}
  */
  get shippingAmount() { return this.dto.shippingAmount; }
  set shippingAmount(value) { this.dto.shippingAmount = value; }
  /**
  * @type {double}
  */
  get vatRate() { return this.dto.vatRate; }
  set vatRate(value) { this.dto.vatRate = value; }
  /**
  * @type {double}
  */
  get vatAmount() { return this.dto.vatAmount; }
  /**
  */
  get shippingMethod() { return this.dto.shippingMethod; }
  set shippingMethod(value) { this.dto.shippingMethod = value; }
  /**
  */
  get isShippingAmountCalculated() { return this.dto.isShippingAmountCalculated; }
  set isShippingAmountCalculated(value) { this.dto.isShippingAmountCalculated = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.shippingamount);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.shippingAmount = value;
    value = Number.parseFloat(qs.vatrate);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.vatRate = value;
    this.dto.shippingMethod = qs.shippingmethod;
    value = qs.isShippingAmountCalculated === 'true' ? true : qs.isshippingamountcalculated;
    value = qs.isShippingAmountCalculated === 'false' ? false : undefined;
    this.dto.isShippingAmountCalculated = value;
  }
}
